import React, {useState} from "react"

import {FieldEditableMode, FieldEditableProps} from "../../../../../proto/render/editable"
import {FieldViewSize} from "../../../../../const"

const debug = false
// const debug = "FieldProjectType_Editable"

export default function FieldProjectType_Editable(props:FieldEditableProps) {

    // STATE & hovered
    const [mode, setMode] = useState(FieldEditableMode.VIEW)

    const onMouseEnter = () => {
        if (props.disabled || !props.field.canEdit(props.model)) return false

        if (mode === FieldEditableMode.VIEW) {
            setMode(FieldEditableMode.HOVERED)
        }
    }

    const onMouseLeave = () => {
        if (mode === FieldEditableMode.HOVERED) setMode(FieldEditableMode.VIEW)
    }

    const onClick = () => {
        if (props.disabled || !props.field.canEdit(props.model)) return false

        gd.modals.project.move(null, props.model.id)
        setMode(FieldEditableMode.VIEW)
    }

    const value         = props.field.getViewValue(props.model)
    const displayValue  = props.field.getDisplayValue(value)

    const classes = Classes("ui5-field-editable", props.className, {
        "ui5-txt-default"               : props.size === FieldViewSize.DEFAULT,
        "size-default"                  : props.size === FieldViewSize.DEFAULT,
        "ui5-txt-less-important-small"  : props.size === FieldViewSize.SMALL,
        "size-small"                    : props.size === FieldViewSize.SMALL,
    })

    const renderHovered = () => {
        const hoveredClasses = Classes(classes, "is-hovered")

        return (
            <div className      = {hoveredClasses}
                 onMouseLeave   = {onMouseLeave}
                 onClick        = {onClick}>
                <div className="txt-truncate">{displayValue}</div>
                <div className="ui5-ico-14 action i5-move m-l-10"/>
            </div>
        )
    }

    const renderView = () => {
        return (
            <div className      = {classes}
                 onMouseEnter   = {onMouseEnter}
                 onClick        = {onClick}>
                <div className="max-w-100-percent txt-truncate">{displayValue}</div>
            </div>
        )
    }

    switch (mode) {
        case FieldEditableMode.HOVERED  :
            return renderHovered()

        case FieldEditableMode.VIEW     :
        default                         :
            return renderView()
    }
}
